var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-dark pt-4 pb-5 text-trans text-center"},[_c('b-container',[_c('b-row',[_c('b-col',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.siteText.footer)}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }